import * as React from 'react'
import {FC} from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../lib/MobXProvider'
import {WidgetApi} from '../../lib/WidgetApi'
import {BlockProps} from '../../lib/Block'
import {DynamicComponentType} from '../../lib/DynamicComponents'

///////////////////////////////////////////////////////////////////////////////

export type DynamicBlockHeaderProps = BlockProps & {
  component: DynamicComponentType
  title: string

  [key: string]: any
}

///////////////////////////////////////////////////////////////////////////////

export const DynamicBlockHeader: FC<DynamicBlockHeaderProps> = observer(
  (props) => {
    const {api} = useStores<{api: WidgetApi}>()
    const {title, position} = props

    return (
      <div className="widget-block-header">
        <h2 className="title">
          {position !== undefined && (
            <span className="position">{position}</span>
          )}
          <span className="text">{api.trans(title)}</span>
        </h2>
      </div>
    )
  },
)
